import { Popover } from '@headlessui/react'
import { InformationCircleIcon, XIcon } from '@heroicons/react/solid'
import classNames from 'classnames'
import { ReactNode } from 'react'

interface Props {
  icon?: ReactNode | false
  title?: string
  subTitle?: any
  children?: ReactNode
  divider?: boolean
  className?: string
  closeIcon?: boolean
}

const CustomTooltip1 = (props: Props) => {
  const {
    icon,
    title,
    subTitle,
    children,
    divider = true,
    className,
    closeIcon = true,
  } = props

  return (
    <Popover className={'relative'}>
      <Popover.Button className={' flex items-center !outline-none'}>
        {children}
      </Popover.Button>

      <Popover.Panel className={'absolute z-50 mt-3 translate-x-[6rem]'}>
        {({ close, open }) => {
          return (
            <div
              className={classNames(
                className,
                'text-white w-[361px]  z-50  bg-[#334155] rounded-lg'
              )}
            >
              <div className={'flex items-center p-2'}>
                <div className={'flex flex-1 items-center  m-1  '}>
                  <div className={'flex self-start'}>
                    {icon || (
                      <InformationCircleIcon
                        className={' w-[2rem]  ml-1  self-start '}
                      />
                    )}
                  </div>
                  <span
                    className={
                      'text-[10px] text-[#94A3B8] text-center font-semibold leading-[32px]'
                    }
                  >
                    {title || 'اطلاعات بیشتر'}
                  </span>
                </div>

                {closeIcon ? (
                  <XIcon
                    className={
                      'w-4 h-4  text-[#94b8a3] cursor-pointer self-start mt-[8px] ml-[8px]'
                    }
                    onClick={() => close()}
                  />
                ) : null}
              </div>

              {divider && (
                <div className="border-dashed border-t border-1 border-[#60666C]"></div>
              )}

              <div className="text-[12px] font-normal text-right leading-7  pr-[18px] pl-[21px] pb-[15px]">
                {open && subTitle}
              </div>
            </div>
          )
        }}
      </Popover.Panel>
    </Popover>
  )
}

export default CustomTooltip1
